import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseChipInput } from './ChipsField'

const CHIP_CONFIGS = {
  forcePreferences: {
    name: 'forcePreferences',
    labelKey: 'header.settings.preference',
    placeholderKey: 'header.settings.preference.placeholder',
    defaultLabel: 'Preference',
    defaultPlaceholder: 'Enter preference value and press Enter',
  },
  forcePermissions: {
    name: 'forcePermissions',
    labelKey: 'header.settings.permission',
    placeholderKey: 'header.settings.permission.placeholder',
    defaultLabel: 'Permission',
    defaultPlaceholder: 'Enter permission value and press Enter',
  },
}

function createChipInputComponent(fieldName) {
  return function ChipInputComponent({ methods }) {
    const { t } = useTranslation()
    const config = CHIP_CONFIGS[fieldName]

    return (
      <BaseChipInput
        name={config.name}
        methods={methods}
        label={t(config.labelKey, config.defaultLabel)}
        placeholder={t(config.placeholderKey, config.defaultPlaceholder)}
      />
    )
  }
}

export const PreferenceInputChips = createChipInputComponent('forcePreferences')
export const PermissionInputChips = createChipInputComponent('forcePermissions')
